import React, { useState } from 'react';

const TEXT = [['resumen', 'Diagnóstico'], ['objetivo', 'Objetivo'], ['apreciacion', 'Apreciación'], ['fundamento_apreciacion', 'Fundamento']];
const LISTS = [['lineas', 'Líneas de acción'], ['normas', 'Normas'], ['riesgos', 'Riesgos'], ['proximos_pasos', 'Próximos pasos'], ['documentos_faltantes', 'Documentos faltantes']];
const items = (c, k) => (c[k] || []).map((x) => (typeof x === 'string' ? x : `${x.titulo}: ${x.detalle}`));
const APR = { favorable: 'Favorable', incierta: 'Incierta', desfavorable: 'Desfavorable' };
const when = (iso) => (iso ? new Date(iso).toLocaleString('es-CL', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }) : '');

const Col = ({ c, other, side }) => (
  <div className="min-w-0 space-y-2">
    {TEXT.map(([k, l]) => (
      <div key={k}>
        <p className="text-[10px] font-semibold uppercase text-slate-500">{l}</p>
        <p className={`text-[11px] ${(c[k] || '') !== (other[k] || '') ? 'rounded bg-amber-500/10 text-amber-100' : 'text-slate-300'}`}>{(k === 'apreciacion' ? APR[c[k]] : c[k]) || '—'}</p>
      </div>
    ))}
    {LISTS.map(([k, l]) => {
      const o = new Set(items(other, k));
      return (
        <div key={k}>
          <p className="text-[10px] font-semibold uppercase text-slate-500">{l}</p>
          <ul className="space-y-0.5">{items(c, k).map((x, i) => (
            <li key={i} className={`text-[11px] ${o.has(x) ? 'text-slate-300' : side === 'a' ? 'text-red-300 line-through' : 'text-emerald-300'}`}>{x}</li>
          ))}</ul>
        </div>
      );
    })}
  </div>
);

// Side-by-side comparison of two approved strategy versions; removed items in red, new ones in green, changed texts highlighted
export const StrategyCompare = ({ current, history }) => {
  const versions = [...history.map((h, i) => ({ ...h, version: h.version || i + 1 })), { ...current, version: current.version || history.length + 1 }];
  const [a, setA] = useState(versions.length - 2);
  const [b, setB] = useState(versions.length - 1);
  const sel = (v, set, testid) => (
    <select data-testid={testid} value={v} onChange={(e) => set(Number(e.target.value))} className="rounded border border-slate-600 bg-slate-800 px-2 py-0.5 text-[11px] text-white">
      {versions.map((x, i) => <option key={i} value={i}>v{x.version} · {when(x.reviewed_at)}</option>)}
    </select>
  );
  return (
    <div data-testid="strategy-compare" className="mt-2 space-y-2 rounded-lg border border-slate-700 bg-slate-900/60 p-2">
      <div className="grid grid-cols-2 gap-3">{sel(a, setA, 'strategy-compare-a')}{sel(b, setB, 'strategy-compare-b')}</div>
      <div className="grid grid-cols-2 gap-3">
        <Col c={versions[a].content || {}} other={versions[b].content || {}} side="a" />
        <Col c={versions[b].content || {}} other={versions[a].content || {}} side="b" />
      </div>
      {(versions[b].cambios || []).length > 0 && <p className="text-[11px] text-slate-400">Motivo de la v{versions[b].version}: {versions[b].cambios.join(' · ')}</p>}
    </div>
  );
};
